export default __webpack_public_path__ + "static/media/Wallpaper-hero-home.32f6995d.png";